import useCountryAxiosInstance from "./useCountryAxiosInstance";

const useGetSurveyResponses = () => {
  const apiRequest = useCountryAxiosInstance();

  return (surveyId) =>
    apiRequest.get(
      `/service_survey_responses/all?service_survey_id=${surveyId}`
    );
};

export default useGetSurveyResponses;
